  export enum VoyageTopbarEventNames {
    ClosePolarRouteSelection = "close-polar-route-selection",
    ShowFeedbackForm = "show-feedback-form",
    ShowPolarRouteSelection = "show-polar-route-selection",
    ShowWeatherLimits = "show-weather-limits",
    ShowDepthsControl = "show-depths-control",
    ShowVesselCharacteristics = "show-vessel-characteristics",
    ShowVesselPosition = "show-vessel-position",
    ShowAlarmLogs = "show-alarm-logs",
    ShowPolarChart = "show-polar-chart",
    ShowWniReports = "show-wni-reports",
    ShowAudioAlert = "show-audio-alert",
    ShowHelpCenter = "show-help-center",
  }